import { render, staticRenderFns } from "./DictamenCliente.vue?vue&type=template&id=e3518c94&scoped=true"
import script from "./DictamenCliente.vue?vue&type=script&lang=js"
export * from "./DictamenCliente.vue?vue&type=script&lang=js"
import style0 from "./DictamenCliente.vue?vue&type=style&index=0&id=e3518c94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3518c94",
  null
  
)

export default component.exports